/**
 * Voting instructions for agenda item changes or new agenda items
 */
export enum VotingInstructionsEnum {
    Invalid = -1,
    AgreeBoardOfDirectors = 1,
    DisagreeBoardOfDirectors = 2,
    Abstention = 3,
    NotGiven = 4,
    Yes = 5,
    No = 6
}

export class VotingInstructionsEnumExtensions {
    static getDescriptionKey(instruction: VotingInstructionsEnum): string {
        switch (instruction) {
            case VotingInstructionsEnum.Invalid:
                return 'GMShareholders.VotingInstructions.Invalid';
            case VotingInstructionsEnum.AgreeBoardOfDirectors:
                return 'GMShareholders.VotingInstructions.AgreeBoardOfDirectors';
            case VotingInstructionsEnum.DisagreeBoardOfDirectors:
                return 'GMShareholders.VotingInstructions.DisagreeBoardOfDirectors';
            case VotingInstructionsEnum.Abstention:
                return 'GMShareholders.VotingInstructions.Abstention';
            case VotingInstructionsEnum.NotGiven:
                return 'GMShareholders.VotingInstructions.NotGiven';
            case VotingInstructionsEnum.Yes:
                return 'GMShareholders.VotingInstructions.Yes';
            case VotingInstructionsEnum.No:
                return 'GMShareholders.VotingInstructions.No';
        }
    }
}
